__turbopack_context__.v({
  "image": "ImageBlock-module__sbMr_q__image",
  "imageBlock": "ImageBlock-module__sbMr_q__imageBlock",
  "imageBlock__container": "ImageBlock-module__sbMr_q__imageBlock__container",
});
